export type SortDirection = "asc" | "desc";

export type SortState = {
  key: string;
  direction: SortDirection;
};

const normalizeSortValue = (value: unknown) => {
  if (value === null || value === undefined || value === "") return "";
  if (value instanceof Date) return value.getTime();
  if (typeof value === "number") return value;
  if (typeof value === "boolean") return value ? 1 : 0;

  const date = new Date(value as any);
  if (
    typeof value === "string" &&
    /^\d{4}-\d{2}-\d{2}/.test(value) &&
    !Number.isNaN(date.getTime())
  ) {
    return date.getTime();
  }

  const numeric = Number(value);
  if (typeof value !== "string" && !Number.isNaN(numeric)) return numeric;

  return String(value).toLocaleLowerCase("vi-VN").trim();
};

export const compareSortValues = (
  first: unknown,
  second: unknown,
  direction: SortDirection,
) => {
  const a = normalizeSortValue(first);
  const b = normalizeSortValue(second);
  const multiplier = direction === "asc" ? 1 : -1;

  if (a === "" && b !== "") return 1;
  if (a !== "" && b === "") return -1;
  if (typeof a === "number" && typeof b === "number") {
    return (a - b) * multiplier;
  }

  return String(a).localeCompare(String(b), "vi-VN", {
    numeric: true,
    sensitivity: "base",
  }) * multiplier;
};

export const nextSortState = (
  current: SortState,
  key: string,
): SortState => ({
  key,
  direction:
    current.key === key && current.direction === "asc" ? "desc" : "asc",
});

export const sortIndicator = (current: SortState, key: string) => {
  if (current.key !== key) return "↕";
  return current.direction === "asc" ? "↑" : "↓";
};
